import { ItemKind } from '../../../constants/ItemKind';
import { systemFolderId } from '../../../constants/system-folder-id';
import { splitTags } from '../../../utils/utils';
export function toFolder(folderData, settings) {
  /**
   * Folder
   * {String} id
   * {String} kind
   * {String} parentId
   * {String} name
   * {String} mediaType
   * {Number} filesCount
   * {Number} createdAt
   * {String} siteId
   * {String} userId
   * {string[]} tags
   */
  var source = folderData.root_id === systemFolderId.VisitorUploads ? 'visitorsUploads' : 'private';
  return {
    id: folderData.folder_id,
    kind: ItemKind.Folder,
    source: settings.sourceName || source,
    parentId: folderData.parent_folder_id || null,
    name: folderData.folder_name,
    mediaType: folderData.media_type,
    filesCount: folderData.files_count,
    createdAt: folderData.created_ts,
    updatedAt: folderData.modified_ts,
    siteId: folderData.site_id,
    userId: folderData.user_id,
    tags: splitTags(folderData.tags),
    siteMediaToken: folderData.token || settings.siteMediaToken
  };
}